import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../environments/environment';
import { UserService } from './user.service';
import { SignatureServiceService } from './signature-service.service';

@Injectable({
  providedIn: 'root'
})
export class NavLinksService {

  private apiUrl = environment.apiUrl;

  private token: string;
  constructor(private http: HttpClient, private userService: UserService, private signatureService: SignatureServiceService) {
    this.token = this.userService.getAccessToken();
  }

  getMenuBasedOnRole(Role: string, CustomerId: number, ServiceProvider: number, UserId: number): Observable<HttpResponse<any>> {
    const hmacPayload = { Role: Role, CustomerId: CustomerId, ServiceProvider: ServiceProvider, UserId: UserId };
    return from(this.signatureService.generateHMACSignature(hmacPayload)).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${this.userService.getAccessToken()}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/MenuHandler/GetMenuBasedOnRole?Role=${Role}&CustomerId=${CustomerId}&ServiceProvider=${ServiceProvider}&UserId=${UserId}`;
        return this.http.get(url, { headers: headers, observe: 'response' });
      }));
  }
  LogoutJTIUpdate(token: any): Observable<HttpResponse<any>> {
    const encodedToken = encodeURIComponent(token);
    return from(this.signatureService.generateHMACSignature( {encodedToken} )).pipe(
      switchMap(signature => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'X-HMAC-Signature': signature
        });
        const url = `${this.apiUrl}/api/Auth/LogoutJTIUpdate?jwttoken=${encodedToken}`;
        return this.http.post(url, [], { headers: headers, observe: 'response' });
      }));
  }
}
